// src/component/PrivateRoute.js

import React, { useEffect, useState } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PrivateRoute = () => {
  const { authenticated, checkAuth } = useAuth();
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (!localStorage.getItem("user")) {
      setLoading(false);
      return;
    }

    // After a successful login, rely on in-memory auth state and avoid
    // immediate re-validation that can race and return 401.
    if (authenticated) {
      setLoading(false);
      return;
    }

    const verifyAuth = async () => {
      await checkAuth();
      setLoading(false);
    };

    verifyAuth();
  }, [authenticated, checkAuth, location]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return authenticated ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoute;
